
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[site]/services",
      function () {
        return require("private-next-pages/_sites/[site]/services/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/[site]/services"])
      });
    }
  